import {
  Highlight,
  Image,
  Stack,
  Text,
  useColorModeValue,
  VStack,
  SimpleGrid,
} from "@chakra-ui/react";
import Tilt from "react-parallax-tilt";
import "aos/dist/aos.css";
import Github from "./Github";

const GithubComp = () => {
  const HeadingColor = useColorModeValue("black", "white");
  const QueryColor = useColorModeValue("#e53e3e", "#eac288");

  return (
    <Stack mt={{ base: 10, sm: 16 }} px={{ base: 4, sm: 8 }} py={10}>
      <Stack
        justifyContent="center"
        alignItems="center"
        w="full"
        maxW="1400px"
        mx="auto"
        spacing={10}
      >
        {/* Your GitHub component */}
        <Github />

        {/* Section Heading */}
        <VStack spacing={8}>
          <Tilt>
            <Stack textAlign="center" data-aos="zoom-in" spacing={2}>
              <Text
                color={HeadingColor}
                fontSize={{ base: "2xl", sm: "3xl", md: "4xl" }}
                fontWeight="semibold"
              >
                <Highlight query="STATISTICS" styles={{ color: QueryColor }}>
                  GITHUB STATISTICS
                </Highlight>
              </Text>
              <Text fontSize="md" color="gray.500">
                My overall statistics, activity, and open-source contributions
              </Text>
            </Stack>
          </Tilt>

          {/* GitHub Stats Section */}
          <SimpleGrid
            columns={{ base: 1, md: 2 }}
            spacing={6}
            justifyItems="center"
            alignItems="center"
          >
            <Image
              src="https://github-readme-stats.vercel.app/api?username=suFi7867&show_icons=true&locale=en&theme=tokyonight"
              alt="GitHub Stats"
            />

            <Image
              w={{ base: "90%", md: "70%" }}
              src="https://github-readme-stats.vercel.app/api/top-langs/?username=suFi7867&layout=compact&theme=tokyonight"
              alt="Top Languages"
            />
          </SimpleGrid>

          {/* Contribution Graph */}
          <Image
            w={{ base: "100%", md: "50%" }}
            src="https://github-readme-activity-graph.vercel.app/graph?username=suFi7867&theme=react-dark"
            alt="GitHub Contribution Graph"
          />

          {/* Trophy Board */}
          <Image
            w={{ base: "95%", md: "80%" }}
            src="https://github-profile-trophy.vercel.app/?username=suFi7867&theme=algolia&margin-w=15&margin-h=15"
            alt="GitHub Trophies"
          />
        </VStack>
      </Stack>
    </Stack>
  );
};

export default GithubComp;
